
import './App.css';
import About from './components/About-us';
import Service from './components/Service';
import Website from './components/Website-development';
import Contact from './components/Contact-us';
import Footer from './components/Footer';
import Home from './components/Home';
import Nave from './components/Nave';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Nave />
        <Routes>
          <Route path="/about-us" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/website-development" element={<Website />} />
          <Route path="/" element={<Home />} />
        </Routes>
      <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
